var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenPlanLivingArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 3L6.73519 6.24398C6.55803 6.38537 6.33809 6.46237 6.11142 6.46237H4C3.44771 6.46237 3 6.91009 3 7.46237V13.7312M3 13.7312V20C3 20.5523 3.44772 21 4 21H11.6154M3 13.7312H8.46154M11.6154 16.3714V21M11.6154 21H20C20.5523 21 21 20.5523 21 20V12.3948M21 12.3948V7.46238C21 6.91009 20.5523 6.46237 20 6.46237H12.6154V12.3948H21Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPlanLivingArea);
export default __webpack_public_path__ + "static/media/open_plan_living_area.589fd3084e5e860b2d759a7c644b1f29.svg";
export { ForwardRef as ReactComponent };